import { Env } from "../env.type";

const env: Env = {
  host: "https://padrinho-veterano.yduqs.com.br",
  nameAplication: "Sistema de gestão do programa Padrinho Veterano & Angels",
  initialsApplication: "PV",
  env: "prd",
  brand: "yduqs",
  api: "https://api.padrinho-veterano.yduqs.com.br",
  apm: "",
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID!,
    authority: process.env.REACT_APP_AUTHORITY!,
    scopes: [`${process.env.REACT_APP_CLIENT_ID!}/.default`],
  },
};

export default env;
